var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import moment from 'moment';
import { get } from 'lodash';
import SeniorCallLogsComponent, { SORTABLE_COLUMNS, } from './SeniorCallLogs.component';
import { getCallLogs } from './SeniorCallLogs.action';
import { PaginationTable } from 'hoc/withPagination/withPagination';
import { TABLE_CACHE_KEY, TABLE_ROWS_PER_PAGE } from 'globals/global.constants';
import { closeDialog } from 'store/commonReducer/common.action';
var DEFAULT_FILTERS = {
    callType: 'All',
    callDirection: 'All',
    startDate: '',
    endDate: '',
};
var SeniorCallLogs = function (props) {
    var dispatch = useAppDispatch();
    var currentSeniorId = useAppSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.common) === null || _a === void 0 ? void 0 : _a.seniorDetail) === null || _b === void 0 ? void 0 : _b.minimalInfo) === null || _c === void 0 ? void 0 : _c.user_id; });
    var tableData = useAppSelector(function (state) { return state.common.currentTableData.data; }) || [];
    var _a = useState(''), sortBy = _a[0], setSortBy = _a[1];
    var _b = useState('asc'), sortOrder = _b[0], setSortOrder = _b[1];
    var _c = useState(DEFAULT_FILTERS), filters = _c[0], setFilters = _c[1];
    var _d = useState('All'), careAgent = _d[0], setCareAgent = _d[1];
    var _e = useState(new Set()), allCareAgentNames = _e[0], setAllCareAgentNames = _e[1];
    var handleSort = function (columnKey) {
        if (sortBy === columnKey) {
            setSortOrder(function (prevOrder) { return (prevOrder === 'asc' ? 'desc' : 'asc'); });
        }
        else {
            setSortBy(columnKey);
            setSortOrder('asc');
        }
    };
    useEffect(function () {
        return function () {
            dispatch(closeDialog());
        };
    }, []);
    useEffect(function () {
        setAllCareAgentNames(function (prev) {
            var changed = false;
            var next = new Set(prev);
            tableData.forEach(function (row) {
                if ((row === null || row === void 0 ? void 0 : row.careagent_name) && !next.has(row.careagent_name)) {
                    next.add(row.careagent_name);
                    changed = true;
                }
            });
            return changed ? next : prev;
        });
    }, [tableData]);
    var careAgentOptions = React.useMemo(function () {
        return __spreadArray([
            'All'
        ], Array.from(allCareAgentNames).sort(function (a, b) { return a.localeCompare(b); }), true);
    }, [allCareAgentNames]);
    var handleCareAgentChange = function (value) {
        setCareAgent(value);
    };
    var careAgentFilterFn = React.useMemo(function () {
        if (!careAgent || careAgent === 'All')
            return undefined;
        return function (row) { return row.careagent_name === careAgent; };
    }, [careAgent]);
    var comparator = React.useMemo(function () {
        if (!sortBy)
            return undefined;
        var column = SORTABLE_COLUMNS.find(function (col) { return col.key === sortBy; });
        if (!column)
            return undefined;
        return function (a, b) {
            var result = 0;
            if (column.field === 'call_time') {
                result = moment(a.call_time).valueOf() - moment(b.call_time).valueOf();
            }
            else {
                var valueA = String(get(a, column.field, '') || '');
                var valueB = String(get(b, column.field, '') || '');
                result = valueA.localeCompare(valueB);
            }
            return sortOrder === 'asc' ? result : -result;
        };
    }, [sortBy, sortOrder]);
    var _f = useState(new Set()), globalLatestThreeCallIds = _f[0], setGlobalLatestThreeCallIds = _f[1];
    var hasCapturedLatestThree = useRef(false);
    var getCallLogsHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getCallLogs(filters)).then(function (res) {
                        res.data = res.data.sort(function (a, b) {
                            var aCallTime = moment(a.call_time);
                            var bCallTime = moment(b.call_time);
                            return aCallTime - bCallTime;
                        });
                        if (!hasCapturedLatestThree.current) {
                            hasCapturedLatestThree.current = true;
                            var sortedByTimeDesc = __spreadArray([], res.data, true).sort(function (a, b) {
                                return moment(b.call_time).valueOf() - moment(a.call_time).valueOf();
                            });
                            setGlobalLatestThreeCallIds(new Set(sortedByTimeDesc.slice(0, 3).map(function (row) { return row.call_id; })));
                        }
                        return res;
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    useEffect(function () {
        getCallLogsHandler();
    }, []);
    var handleFiltersChange = function (newFilters) {
        localStorage.removeItem('callLogs');
        setFilters(newFilters);
    };
    var cacheKey = React.useMemo(function () {
        return "".concat(TABLE_CACHE_KEY.CALL_LOGS, "-").concat(currentSeniorId, "-").concat(JSON.stringify(filters));
    }, [currentSeniorId, filters]);
    // HOC props
    var withPaginationProps = {
        getData: getCallLogsHandler,
        cacheKey: cacheKey,
        rowsPerPage: TABLE_ROWS_PER_PAGE,
        comparator: comparator,
        filterFn: careAgentFilterFn,
    };
    var enhancedProps = __assign(__assign({}, props), { sortBy: sortBy, sortOrder: sortOrder, onSort: handleSort, filters: filters, onFiltersChange: handleFiltersChange, careAgent: careAgent, careAgentOptions: careAgentOptions, onCareAgentChange: handleCareAgentChange, latestThreeCallIds: globalLatestThreeCallIds });
    return (_jsx(PaginationTable, __assign({ WrappedComponent: SeniorCallLogsComponent, componentProps: enhancedProps }, withPaginationProps)));
};
export default SeniorCallLogs;
